import { useContext } from "react";
import { Redirect } from "react-router";
import translate from "../../common/functions/translate";
import { usePageTitle } from "../../common/hooks/usePageTitle";
import { globalData } from "../../globalContext";
import { LoginConfirmYourMethod } from "../LoginConfirmMethod";

export const LoginEnterCode = () => {
    const { mfaLoginData } = useContext(globalData);
    const { username, password, type, value, id } = mfaLoginData;

    // missing context data
    if (!username || !password || !type || !value || !id) {
        return <Redirect to="/login" />;
    }

    return (
        <LoginConfirmYourMethod
            type={type}
            value={value}
            username={username}
            password={password}
            id={id}
        />
    );
}